import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "time",
  "use": "time-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"time\">\n  <path fill-rule=\"evenodd\" d=\"M470,278a8,8,0,1,1,8-8A8.009,8.009,0,0,1,470,278Zm0-14.4a6.407,6.407,0,1,0,6.41,6.407A6.415,6.415,0,0,0,470,263.593Zm1.6,9.62-2.166-2.165a0.8,0.8,0,0,1-.233-0.562v-4.33H470.8v4l1.933,1.932Z\" transform=\"translate(-462 -262)\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/time.svg
// module id = null
// module chunks = 